import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  templateUrl: 'form-field-wrapper.component.html',
  imports: [...MSS_FORMLY_IMPORTS],
})
export class FormFieldWrapperComponent extends FieldWrapper {
  get labelClass(): string {
    return this.props.labelClass ?? '';
  }
}
